import React, { memo } from 'react';
import { useAppSelector, useAppDispatch } from '../store/hooks';
import { selectOnboardingStage, selectOnboardingById } from '../store/onboardingSlice';
import { 
  setModalOnboarding 
} from '../store/onboardingSlice';

// import '../OnboardingView.css';
import './OnboardingCell.css';
import '../../../App.css';



const BlankCell = () => {
  return (
    <div className="cell-content">
      
    </div>
  )
}

const OverviewCell = ({ onboardingId }) => {
  const onboarding = useAppSelector(state => selectOnboardingById(state, onboardingId));
  //console.log("OverviewCell: ", onboarding);
  return (
    <div className="overview-cell-container">
      <span 
        className="overview-cell-name clickable-practice-id" 
        onClick={(e) => {
          e.stopPropagation(); // Prevent the OnboardingCell click from firing
          navigator.clipboard.writeText(onboarding?.name);
        }}
      >
        {onboarding.name}
      </span>
      {onboarding.productType === "non-voip" && (
        <span className="non-voip-icon" title="Non-VoIP Onboarding">
          📵
        </span>
      )}
    </div>
  )
}

const isGeneric = (stage) => {
  //console.log("isGeneric: ", stage);
  return stage.status === 'new' || stage.status === 'scheduled' || stage.status === 'completed' || stage.status === 'follow-up' || stage.status === 'on-hold' || stage.status === 'pending' || stage.status === 'blocked' || stage.status === 'needs-action';
}

const GenericFormatCell = (stage) => {
  //console.log("GenericFormatCell: ", stage);
  if (stage.status === 'new') {
    return '';
  }
  if (stage.status === 'completed') {
    return (
      <div className="generic-format-cell-container">
        <span className="generic-format-cell-status-completed">
          {new Date(stage.history[stage.history.length - 1]?.timestamp).toLocaleDateString()}
        </span>
      </div>
    )
  }
  if (stage.status === 'scheduled') {
    return (
      <div className="generic-format-cell-container">
        <span className="generic-format-cell-status-scheduled">
          {new Date(stage.history[stage.history.length - 1]?.data?.scheduledTime).toLocaleString()}
        </span>
      </div>
    )
  }
  if (stage.status === 'follow-up') {
    return (
      <div className="generic-format-cell-container">
        <span className="generic-format-cell-status-follow-up">
          Follow-up
        </span>
      </div>
    )
  }
  if (stage.status === 'on-hold') {
    return (
      <div className="generic-format-cell-container">
        <span className="generic-format-cell-status-on-hold">
          On Hold
        </span>
      </div>
    )
  }
  if (stage.status === 'blocked' || stage.status === 'needs-action') {
    return (
      <div className="generic-format-cell-container">
        <span className="generic-format-cell-status-blocked">
          {stage.status === 'blocked' ? 'Blocked' : 'Needs Action'}
        </span>
      </div>
    )
  }
  if (stage.status === 'pending') {
    return (
      <div className="generic-format-cell-container">
        <span className="generic-format-cell-status-pending">
          Pending
        </span>
      </div>
    )
  }
  return null;
}

const SignedDateCell = ({ stage }) => {
  console.log("SignedDateCell: ", stage);
  return (
    <div className="cell-content">
      {stage.status || 'Not started'}
    </div>
  )
}

const KickoffCell = ({ stage }) => {
  return (
    <div className="cell-content">
      {stage.status || 'Not started'}
    </div>
  )
}

const LinkedToPracticeCell = ({ stage, onboardingId }) => {
  const onboarding = useAppSelector(state => selectOnboardingById(state, onboardingId));
  return (
    <div className="overview-cell-container">
    <span 
      className="overview-cell-name clickable-practice-id" 
      onClick={(e) => {
        e.stopPropagation(); // Prevent the OnboardingCell click from firing
        navigator.clipboard.writeText(onboarding.practiceId);
      }}
    >
        {onboarding.practiceId ?? onboarding.practiceId}
      </span>
    </div>
  )
}

const RegistrationCompleteCell = ({ stage }) => {
  return (
    <div className="cell-content">
      {stage.status || 'Not started'}
    </div>
  )
}


const DisplayIndividualPort = ({ stage, portId }) => {
  return (
    <div className="port-request-cell-item">
      {portId}
    </div>
  )
}

const PortRequestCell = ({ stage }) => {
  const portIds = Object.keys(stage.final_data);
  if (!portIds || portIds.length === 0) {
    return (
       <BlankCell />
    )
  }
  return (
    <div className="port-request-cell-container">
      {portIds.map((key, index) => (
        <DisplayIndividualPort key={index} stage={stage} portId={key} />
      ))}
    </div>
  );
}

const PhonesCell = ({ stage, onboardingId }) => {
  const onboarding = useAppSelector(state => selectOnboardingById(state, onboardingId));
  const isNonVoip = onboarding?.product === "non-voip";
  
  return (
    <div className={`cell-content ${isNonVoip ? 'non-voip-phones-cell' : ''}`}>
      {stage.status || 'Not started'}
    </div>
  )
}

const TrainingKbCell = ({ stage }) => {
  return (
    <div className="cell-content">
      {stage.status || 'Not started'}
    </div>
  )
}

const TrainingWorkflowCell = ({ stage }) => {
  return (
    <div className="cell-content">
      {stage.status || 'Not started'}
    </div>
  ) 
}

const GoLiveCell = ({ stage }) => {
  return (
    <div className="cell-content">
      {stage.status || 'Not started'}
    </div>
  )
}


const getCellType = (stage) => {
  switch (stage) {
    case 'overview':
      return OverviewCell;
    case 'signedDate':
      return SignedDateCell;
    case 'kickoff':
      return KickoffCell;
    case 'isLinkedToPractice':
      return LinkedToPracticeCell;
    case 'registrationComplete':
      return RegistrationCompleteCell;
    case 'portRequest':
      return PortRequestCell;
    case 'phones':
      return PhonesCell;
    case 'trainingKb':
      return TrainingKbCell;
    case 'trainingWorkflow':
      return TrainingWorkflowCell;
    case 'goLive':
      return GoLiveCell;
    default:
      return null;
  }
}


// Memoized cell component that only re-renders when its specific onboarding changes
const OnboardingCell = memo(({ onboardingId, stage }) => {
  const dispatch = useAppDispatch();
  const onboardingStage = useAppSelector(state => selectOnboardingStage(state, onboardingId, stage));
  if (!onboardingStage) {
    if (stage === 'overview') {
      return (
        <td 
          className="overview-cell-td" 
          onClick={(e) => {
            // Only open modal if clicking on the TD itself, not on the name span
            if (e.target === e.currentTarget) {
              dispatch(setModalOnboarding({onboardingId, stage}));
            }
          }}
        >
          <OverviewCell onboardingId={onboardingId} />
        </td>
      );
    }
    return <td>Loading...</td>;
  }

  //console.log("Cell rendering: ", onboardingId, stage);

  return (
    <td 
      onClick={() => dispatch(setModalOnboarding({onboardingId, stage}))}
    > 
       { isGeneric(onboardingStage)  ? GenericFormatCell(onboardingStage) : 
                                      (() => {
                                        const CellComponent = getCellType(stage);
                                        if (CellComponent === LinkedToPracticeCell || CellComponent === OverviewCell || CellComponent === PhonesCell) {
                                          return <CellComponent stage={onboardingStage} onboardingId={onboardingId} />;
                                        }
                                        return <CellComponent stage={onboardingStage} onboardingId={onboardingId} />;
                                      })()}
    </td>
  );
});

OnboardingCell.displayName = 'OnboardingCell';

export {
  OnboardingCell 
};
